import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import Card from "components/Card/Card.jsx";
import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";

import image01 from "assets/img/slides/Slide01.png"
import image02 from "assets/img/slides/Slide02.png"
import image03 from "assets/img/slides/Slide03.png"
import image04 from "assets/img/slides/Slide04.png"
import image05 from "assets/img/slides/Slide05.png"
import image06 from "assets/img/slides/Slide06.png"
import image07 from "assets/img/slides/Slide07.png"
import image08 from "assets/img/slides/Slide08.png"
import image09 from "assets/img/slides/Slide09.png"
import image10 from "assets/img/slides/Slide10.png"
import image11 from "assets/img/slides/Slide11.png"
import image12 from "assets/img/slides/Slide12.png"
import image13 from "assets/img/slides/Slide13.png"
import image14 from "assets/img/slides/Slide14.png"
import image15 from "assets/img/slides/Slide15.png"
import image16 from "assets/img/slides/Slide16.png"
import image17 from "assets/img/slides/Slide17.png"
import image18 from "assets/img/slides/Slide18.png"
import image19 from "assets/img/slides/Slide19.png"
import image20 from "assets/img/slides/Slide20.png"
import image21 from "assets/img/slides/Slide21.png"

class SectionCarousel extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: false,
      // infinite: true,
      speed: 800,
      slidesToShow: 9,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 800,
      pauseOnHover: false,
      arrows: false
    };
    const listImage = [
      image01, image02, image03, image04, image05, image06, image07, image08, image09, image10,
      image11, image12, image13, image14, image15, image16, image17, image18, image19, image20,
      image21
    ]
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem className={classes.marginAuto}>
            <h2 className={classes.title} style={{ color: "#4BB64B" }}><center><b>Our Clients</b></center></h2>
            <Carousel xs={8} sm={8} md={8} lg={8} xl={8} {...settings}>
              {listImage.map((item, i) => {
                return <div>
                  <img
                    src={item}
                    alt="First slide"
                    className="slick-logo"
                  />
                </div>
              })}
            </Carousel>
            <br/>
          </GridItem>
        </GridContainer>
        <br />
        <br />
        <br />
      </div>
    );
  }
}

export default withStyles(carouselStyle)(SectionCarousel);



// WEBPACK FOOTER //
// ./src/views/HomePage/Sections/Carousel.jsx